import { Languages } from "@/constants/languages";

import femaleCompleteImgEn from "./img/F_Complete.webp";
import femaleCompleteImgEs from "./img/F_Complete-es.webp";
import femaleEnterImgEn from "./img/F_Enter.webp";
import femaleEnterImgEs from "./img/F_Enter-es.webp";
import femaleEnterImgFr from "./img/F_Enter-fr.webp";
import femaleOpenImgEn from "./img/F_Open.webp";
import femaleOpenImgEs from "./img/F_Open-es.webp";
import maleCompleteImgEn from "./img/M_Complete.webp";
import maleCompleteImgEs from "./img/M_Complete-es.webp";
import maleEnterImgEn from "./img/M_Enter.webp";
import maleEnterImgEs from "./img/M_Enter-es.webp";
import maleEnterImgFr from "./img/M_Enter-fr.webp";
import maleOpenImgEn from "./img/M_Open.webp";
import maleOpenImgEs from "./img/M_Open-es.webp";

// TODO: make images refactor, images (for open step) are not used
const mapFemaleOpenImgByLng = {
    [Languages.Spanish]: femaleOpenImgEs,
    [Languages.English]: femaleOpenImgEn,
    [Languages.German]: femaleOpenImgEn,
    [Languages.Portuguese]: femaleOpenImgEn,
    [Languages.French]: femaleOpenImgEn,
};

// TODO: make images refactor, images (for open step) are not used
const mapMaleOpenImgByLng = {
    [Languages.Spanish]: maleOpenImgEs,
    [Languages.English]: maleOpenImgEn,
    [Languages.German]: maleOpenImgEn,
    [Languages.Portuguese]: maleOpenImgEn,
    [Languages.French]: maleOpenImgEn,
};

export const mapFemaleEnterImgByLng = {
    [Languages.Spanish]: femaleEnterImgEs,
    [Languages.English]: femaleEnterImgEn,
    [Languages.German]: femaleEnterImgEn,
    [Languages.Portuguese]: femaleEnterImgEn,
    [Languages.French]: femaleEnterImgFr,
};

export const mapMaleEnterImgByLng = {
    [Languages.Spanish]: maleEnterImgEs,
    [Languages.English]: maleEnterImgEn,
    [Languages.German]: maleEnterImgEn,
    [Languages.Portuguese]: maleEnterImgEn,
    [Languages.French]: maleEnterImgFr,
};

// TODO: make images refactor, images (for complete step) are not used
const mapFemaleCompleteImgByLng = {
    [Languages.Spanish]: femaleCompleteImgEs,
    [Languages.English]: femaleCompleteImgEn,
    [Languages.German]: femaleCompleteImgEn,
    [Languages.Portuguese]: femaleCompleteImgEn,
    [Languages.French]: femaleCompleteImgEn,
};

// TODO: make images refactor, images (for complete step) are not used
const mapMaleCompleteImgByLng = {
    [Languages.Spanish]: maleCompleteImgEs,
    [Languages.English]: maleCompleteImgEn,
    [Languages.German]: maleCompleteImgEn,
    [Languages.Portuguese]: maleCompleteImgEn,
    [Languages.French]: maleCompleteImgEn,
};

export const getImages = (isFemale: boolean, language: Languages) => {
    return {
        open: isFemale ? mapFemaleOpenImgByLng[language] : mapMaleOpenImgByLng[language],
        enter: isFemale ? mapFemaleEnterImgByLng[language] : mapMaleEnterImgByLng[language],
        complete: isFemale
            ? mapFemaleCompleteImgByLng[language]
            : mapMaleCompleteImgByLng[language],
    };
};
